// extracted by mini-css-extract-plugin
export default {"negativeChange":"style_negativeChange__EfU4S","positiveChange":"style_positiveChange__Yrnw+","pagination__input__withPadding":"style_pagination__input__withPadding__+jE6J"};